import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import { AuthContext } from "../../../../contexts/AuthContext";
import { ShowTableJual } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../../components";
import { Colors } from "../../../../constants/styles";
import { postRequest } from "../../../../constants/api";
import { Form } from "react-bootstrap";
import {
  Box,
  Typography,
  Divider,
  Pagination,
  Button,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

const TampilDaftarJual = () => {
  const { user, dispatch } = useContext(AuthContext);
  const screenSize = useScreenWidth();
  const navigate = useNavigate();
  const [isFetchError, setIsFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = useState("No. Nota");
  const [jualsPagination, setJualsPagination] = useState([]);
  const kode = null;

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getJualsPagination();
  }, [page, searchTerm, value]);

  const getJualsPagination = async () => {
    setLoading(true);
    try {
      let tempUrlSwitch;
      switch (value) {
        case "No. Nota":
          tempUrlSwitch = "jualsPagination";
          break;
        case "Nama Pelanggan":
          tempUrlSwitch = "jualsOrderByPelangganPagination";
          break;
        case "Lunas":
          tempUrlSwitch = "jualsLunasPagination";
          break;
        case "Belum Lunas":
          tempUrlSwitch = "jualsBelumLunasPagination";
          break;
      }

      const response = await postRequest(
        `/${tempUrlSwitch}?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {},
        navigate,
        dispatch
      );
      setQuery(searchTerm);
      setJualsPagination(response.data.juals);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Penjualan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Jual
      </Typography>
      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">Sortir</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="No. Nota"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        >
          <FormControlLabel
            value="No. Nota"
            control={<Radio />}
            label="No. Nota"
          />
          <FormControlLabel
            value="Nama Pelanggan"
            control={<Radio />}
            label="Nama Pelanggan"
          />
          <FormControlLabel value="Lunas" control={<Radio />} label="Lunas" />
          <FormControlLabel
            value="Belum Lunas"
            control={<Radio />}
            label="Belum Lunas"
          />
        </RadioGroup>
      </FormControl>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={"/"}
          kode={kode}
          addLink={`/daftarJual/jual/tambahJual`}
          editLink={`/`}
          deleteUser={"/"}
        />
      </Box>
      <Divider sx={dividerStyle} />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Chip
        label="Sudah Lunas"
        sx={{
          backgroundColor: Colors.green400,
        }}
      />
      <Box sx={tableContainer}>
        <ShowTableJual currentPosts={jualsPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilDaftarJual;

const container = {
  p: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
